goog.provide('el8.appchart.printService');

goog.require('el8.appchart.letters.printOrFaxFtue');
goog.require('el8.appchart.refpanel.printOrFax');
goog.require('el8.service.urls');

/**
 * This service exists to allow us to check if the user has seen our FaxLetter FTUE
 * before allowing them to print a document. If they haven't, we will encourage them
 * to try faxing directly through Elation, instead of printing and then manually faxing.
 */
el8.appchart.printService = (function() {

    var faxFtueChecked = false;
    var FTUE_KEY = 'FaxLetter';

    var module = {

            open: function(spec, bypassCheck) {
            if (typeof bypassCheck === 'undefined') bypassCheck = false;
            if (bypassCheck || faxFtueChecked) {
                // we won't prompt the user to check out this FTUE more than once per page session
                doPrint(spec);
                return;
            }
            
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('ftue', [el8.data.currUser.getId(),FTUE_KEY]),
                success: function(res) {
                    faxFtueChecked = true;
                    if (res.data) {
                        doPrint(spec);
                    } else {
                        el8.appchart.letters.printOrFaxFtue.show(spec);
                    }
                },
                error_override: function() {
                    // if something went wrong, just print
                    faxFtueChecked = true;
                    doPrint(spec);
                }
            });
        }

    };


    function doPrint(spec) {
        if (spec.url) {
            window.open(spec.url);
        
        } else if (spec.urlKey) {
            if (spec.urlKey === 'printRefPanel') {
                el8.appchart.refpanel.printOrFax.show();
            } else {
                window.open(el8.service.urls.get(spec.urlKey));    
            }
        
        } else if (spec.printFn) {
            spec.printFn();
        }
    }


    return module;

})();
